import { useUser } from '@/features/tasks/hooks/useUser';
import { useBackendApi } from '@/services/useBackendApi';
import { useMutation, useQuery, useQueryCache } from '@pinia/colada';


export function useReferrals() {
    const Api = useBackendApi();

    return useQuery({
        key: () => ['referrals'],
        query: () => Api.get('/earn/user/referrals'),
    });
}

export function useRegisterReferral() {
    const Api = useBackendApi();
    const queryCache = useQueryCache();
    const { data: user } = useUser();

    return useMutation({
        mutation: ({ referrerId }: { referrerId: string }) =>
            Api.post('/earn/user/set_referrer', { referrerId }),
        onSuccess: () => {
            queryCache.invalidateQueries({ key: ['user'] });
        },
    });
}
